export default function ContactUs() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Contact Us</h1>
          <p>Need assistance? The LEGITIMATELY team is here to help!</p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Email</h2>
              <p>support@legitimately.com</p>
            </div>
            <div className="privacy_title">
              <h2>Phone</h2>
              <p>+1-800-LEGIT-123</p>
            </div>
            <div className="privacy_title">
              <h2>Address</h2>
              <p>123 LEGITIMATELY Avenue, City, State, 12345</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
